import __request__ from "routing/request";
export function get(entity_list_id) {
  return __request__("GET", `/entitylists/preferences/${entity_list_id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function create(JSONbody, entity_list_id) {
  return __request__("POST", `/entitylists/preferences/${entity_list_id}`, JSONbody, {}, {
    "Accept": []
  });
}
